export default __webpack_public_path__ + "static/media/icon-warning.ecfda3b7.svg";